/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface V1VolumeResourceRequirements
 */
export interface V1VolumeResourceRequirements {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof V1VolumeResourceRequirements
     */
    limits?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof V1VolumeResourceRequirements
     */
    requests?: { [key: string]: string; };
}

export function V1VolumeResourceRequirementsFromJSON(json: any): V1VolumeResourceRequirements {
    return V1VolumeResourceRequirementsFromJSONTyped(json, false);
}

export function V1VolumeResourceRequirementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1VolumeResourceRequirements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'limits': !exists(json, 'limits') ? undefined : json['limits'],
        'requests': !exists(json, 'requests') ? undefined : json['requests'],
    };
}

export function V1VolumeResourceRequirementsToJSON(value?: V1VolumeResourceRequirements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'limits': value.limits,
        'requests': value.requests,
    };
}

